import { useCallback, useEffect, useState } from 'react';
import { GetAdminTrialOutreachHistoryAPI } from '../../../../api/AdminAPI';

const HISTORY_LIMIT = 200;

/**
 * useTrialOutreachHistory
 *
 * Histórico do contato com testes (admin/trial_outreach/history.php): o que a
 * rotina diária e o "Enviar mensagem" mandaram, a mais recente primeiro.
 * setOutcome atualiza o resultado em todas as linhas da empresa sem recarregar.
 *
 * @returns {{ items: Array, isLoading: boolean, error: string|null, refresh: Function, setOutcome: Function }}
 */
function useTrialOutreachHistory() {
  const [items, setItems] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  const refresh = useCallback(() => {
    setIsLoading(true);
    setError(null);
    GetAdminTrialOutreachHistoryAPI({ limit: HISTORY_LIMIT }, (response) => {
      if (!response || response.success === false) {
        setError(response?.error || 'Erro ao carregar o histórico. Tente novamente.');
        setIsLoading(false);
        return;
      }
      setItems(response.items || []);
      setIsLoading(false);
    });
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const setOutcome = useCallback((companyId, outcome) => {
    setItems((prev) => prev.map((item) => (item.company_id === companyId ? { ...item, outcome } : item)));
  }, []);

  return { items, isLoading, error, refresh, setOutcome };
}

export default useTrialOutreachHistory;
